import React, { memo } from "react";

import Grid from "@material-ui/core/Grid";
import { useField } from "formik";
import * as Yup from "yup";

import { Input, Switch, withNamespace } from "components/Form/FormikControls";

export const emailRecipientBaseValidation: Yup.SchemaOf<
  Omit<EmailRecipient, "id">
> = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().required("Required").email("Invalid email"),
  phoneNumber: Yup.string(),
  isAccountsRecipient: Yup.boolean(),
  isCommercialReportRecipient: Yup.boolean(),
  isComplianceReportRecipient: Yup.boolean(),
  isEnvdRecipient: Yup.boolean(),
});

interface EmailRecipientFormProps {
  namespace: string;
}

function EmailRecipientFormComponent(
  props: EmailRecipientFormProps,
): React.JSX.Element {
  const { namespace: ns } = props;
  const id = useField(withNamespace(ns, "id"))[0].value;
  const isCommercialReportRecipientField = useField(
    withNamespace(ns, "isCommercialReportRecipient"),
  );
  const isComplianceReportRecipientField = useField(
    withNamespace(ns, "isComplianceReportRecipient"),
  );

  function onAfterEmailChanged() {
    if (!id) {
      // when this is a new EmailRecipient

      if (typeof isCommercialReportRecipientField[0].value !== "boolean") {
        // When the field has not yet been set (boolean once set by user, otherwise undefined)
        isCommercialReportRecipientField[2].setValue(true);
      }

      if (typeof isComplianceReportRecipientField[0].value !== "boolean") {
        // When the field has not yet been set (boolean once set by user, otherwise undefined)
        isComplianceReportRecipientField[2].setValue(true);
      }
    }
  }

  return (
    <>
      <input
        name={withNamespace(ns, "id")}
        type="hidden"
        value={id || undefined}
      />
      <Grid item xs={12} md={4}>
        <Input
          label="Email"
          name={withNamespace(ns, "email")}
          onChangeExtra={onAfterEmailChanged}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Input
          label="First Name"
          name={withNamespace(ns, "firstName")}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Input
          label="Last Name"
          name={withNamespace(ns, "lastName")}
          required
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Input label="Phone" name={withNamespace(ns, "phoneNumber")} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <Switch
          label="Is Accounts Recipient"
          name={withNamespace(ns, "isAccountsRecipient")}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <Switch
          label="Is Commercial Recipient"
          name={withNamespace(ns, "isCommercialReportRecipient")}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <Switch
          label="Is Compliance Recipient"
          name={withNamespace(ns, "isComplianceReportRecipient")}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <Switch
          label="Is eNVD Recipient"
          name={withNamespace(ns, "isEnvdRecipient")}
        />
      </Grid>
    </>
  );
}

export default memo(EmailRecipientFormComponent);
